import { Card } from "@verde/compose-ui";
import {
  BuildingIcon,
  EditIcon,
  FarmProducerIcon,
  WalletIcon,
} from "@verde/icons";
import { People } from "@verde/modules";
import { Alert, Copyable } from "@verde/ui-core";
import FundsSelector from "modules/investment-funds/components/funds-selector";
import { useMemo, useReducer } from "react";
import { useRaioXRuralSearch } from "../pages";

export default function AsideFundManager() {
  const { client } = useRaioXRuralSearch();

  const client_rating = People.VariantByRiskRange(client?.rating);

  const [fundsOptionsOpen, toggleFundOptionsOpen] = useReducer(
    (state) => !state,
    false,
  );

  const makeLabel = useMemo(() => {
    if (client?.rating?.situation === "QUALIFIED") {
      return "Saudável";
    }

    if (client?.rating?.situation === "WITH_OBSERVATION") {
      return "Com observações";
    }

    return "Risco";
  }, [client?.rating]);

  if (!client?.id) return null;

  return (
    <>
      <Card
        size="sm"
        icon={
          {
            COMPANY: <BuildingIcon />,
            PERSON: <FarmProducerIcon />,
          }[client?.person_kind]
        }
        title={
          {
            COMPANY: "Sobre a empresa",
            PERSON: "Sobre o cliente",
          }[client?.person_kind]
        }
      >
        {client?.rating?.id ? (
          <div
            className={`flex items-center gap-2 rounded border  px-4 py-2 ${client_rating.tag}`}
          >
            {client_rating.icon}
            <p className="font-semibold text-brand-green-dark">{makeLabel}</p>
          </div>
        ) : (
          <Alert>Cliente não consultado.</Alert>
        )}
      </Card>

      <Card
        size="sm"
        icon={<WalletIcon />}
        title="Fundos relacionados"
        action={{
          icon: <EditIcon />,
          onClick: toggleFundOptionsOpen,
        }}
      >
        <div className="grid gap-2">
          {!client?.investment_funds?.length && (
            <Alert>Nenhum fundo vinculado.</Alert>
          )}

          {client?.investment_funds.map(({ id, name }) => {
            return (
              <div
                key={`aside-fund-item-${id}`}
                className="rounded border border-neutral-light-2 px-4 py-2 text-base font-semibold"
              >
                {name}
              </div>
            );
          })}
        </div>
      </Card>

      {fundsOptionsOpen && (
        <FundsSelector
          client_id={client.id}
          onClose={toggleFundOptionsOpen}
          defaultValue={client.investment_funds.map((item) => item.id)}
        />
      )}
    </>
  );
}
